/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Retarget PageFly homepage doctor cards to the restored doctors hub.
  // PageFly manages sections/pagefly-home.liquid and overwrites it on
  // re-publish, so the link fix lives here instead. If PageFly is later
  // updated to link /pages/our-doctors directly, this block becomes a no-op.
  var pfFixDoctorLinks = function () {
    document.querySelectorAll('[data-href="/pages/doctors-page"]').forEach(function (el) {
      el.setAttribute('data-href', '/pages/our-doctors');
    });
  };
  pfFixDoctorLinks();
  document.addEventListener('DOMContentLoaded', pfFixDoctorLinks);

  // Blog article template renders its title as <h2 class="article__title">;
  // promote it to <h1> for correct heading semantics (theme section file is
  // app-managed at ~29KB; server-side fix pending a manual editor session).
  var fixArticleTitle = function () {
    var t = document.querySelector('h2.article__title');
    if (t && !document.querySelector('h1.article__title')) {
      var h = document.createElement('h1');
      h.className = t.className;
      h.innerHTML = t.innerHTML;
      t.replaceWith(h);
    }
  };
  fixArticleTitle();
  document.addEventListener('DOMContentLoaded', fixArticleTitle);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
